// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"e618eff9","856":"8e90c3d5","952":"7ec72db7"}[chunkId] + ".chunk.js";
};